module.exports = __webpack_public_path__ + "img/sv.05ba622a.png";